import { ArticleReader } from 'components/blog/ArticleReader';
import { GET_ARTICLE_BY_SLUG } from 'lib/queries';
const { BlogTheme } = require('components/shared/BlogTheme');
import sanityGraphQLClient from '../../utils/sanityGraphQLClient';

const Blog = ({ auth, article }) => {
  return (
    <BlogTheme>
      <ArticleReader auth={auth} article={article} />
    </BlogTheme>
  );
};

export async function getServerSideProps(context) {
  const { params } = context;
  let article = null;

  try {
    const response = await sanityGraphQLClient(GET_ARTICLE_BY_SLUG, {
      where: {
        slug: {
          current: {
            eq: params.articleSlug
          }
        }
      }
    });

    article = response?.allPost[0] || article;
  } catch (error) {
    console.log(error);
  }

  return {
    props: {
      article
    }
  };
}

export default Blog;
